import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { ThemeModeService } from './_stealth/partials/layout/theme-mode-switcher/theme-mode.service';
import { environment } from 'src/environments/environment';

@Component({
    // tslint:disable-next-line:component-selector
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit {  
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );
  }

  ngOnInit() {
    this.modeService.init();
    this.updateAssetUrls();
    document.title = 'ECAM Hub - ' + environment.name;
  }

  private updateAssetUrls(): void {
    // Update favicon
    const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
    if (link) {
      link.href = `${environment.appBaseUrl}/assets/media/logos/ECAM Emblem.ico`;
    }

    // Update splash screen stylesheet
    const splash: HTMLLinkElement | null = document.querySelector("#layout-styles-anchor");
    if (splash) {
      splash.href = `${environment.appBaseUrl}/assets/splash-screen.css`;
    }

    const logos = document.querySelectorAll<HTMLImageElement>("img[src*='assets/media/logos']");
    logos.forEach(img => {
      const originalSrc = img.src;
      const assetPath = originalSrc.substring(originalSrc.indexOf('assets'));
      img.src = `${environment.appBaseUrl}/${assetPath}`;
    });
  }
}
